import { ApprovalStatus } from '../../enums/ApprovalStatus.enum'
import { Currency } from '../../enums/Currency.enum'
import { ReimbursementType } from '../../enums/ReimbursementType.enum'
import { MedicalReimbursement, MedicalReimbursementRaw } from '../MedicalReimbursement'

function fromRaw({ id, rawData }: { id: string; rawData: MedicalReimbursementRaw }): MedicalReimbursement {
  return {
    id,
    approvalStatus: rawData.approvalStatus as ApprovalStatus,
    name: rawData.name,
    email: rawData.email,
    serviceDate: rawData.serviceDate.toDate(),
    serviceDateString: rawData.serviceDateString ?? null,
    reimbursementType: rawData.reimbursementType as ReimbursementType,
    vendor: rawData.vendor,
    description: rawData.description ?? '',
    totalAmountClaimed: {
      currency: rawData.totalAmountClaimed.currency as Currency,
      value: rawData.totalAmountClaimed.value,
    },
    supportingDocumentRef: !!rawData.supportingDocumentRef ? rawData.supportingDocumentRef : null,
    supportingDocumentUrl: !!rawData.supportingDocumentUrl ? rawData.supportingDocumentUrl : null,
    createdAt: !!rawData.createdAt ? rawData.createdAt.toDate() : null,
    approvalUpdatedAt: !!rawData.approvalUpdatedAt ? rawData.approvalUpdatedAt.toDate() : null,
    approvalBy: rawData.approvalBy,
  }
}

const MedicalReimbursementTableHelper = {
  fromRaw,
}

export default MedicalReimbursementTableHelper
